<template>
    <div class="breadcrumbs">
        <div v-if="breadcrumbs" class="breadcrumbs_list">
            <ul>
                <li v-for="(breadcrumb, index) in breadcrumbs"
                    :style="{'width': breadcrumb_width + '%'}" :key="index">
                    <a href="#" :class="{
                        'previous primary_background_dim': breadcrumb.previous,
                        'current primary_background': breadcrumb.current,
                    }">
                        {{breadcrumb.label}}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            breadcrumbs: {
                type: Array,
                default() {
                    return [];
                },
            },
        },
        computed: {
            breadcrumb_width() {
                const self = this;
                return 100 / self.breadcrumbs.length;
            },
        },
    };
</script>

<style scoped="scoped">

    .breadcrumbs .breadcrumbs_list ul {
        list-style: none;
        overflow: hidden;
        padding: 0;
        margin-top: 0;
    }

    .breadcrumbs .breadcrumbs_list ul li {
        float: left;
    }

    .breadcrumbs .breadcrumbs_list ul li a {
        color: black;
        text-decoration: none;
        padding: 10px 0 10px 0;
        position: relative;
        display: block;
        float: left;
        background-color: #EFEFEF;
        text-align: center;
        width: 100%;

        cursor: default;
    }

    .breadcrumbs .breadcrumbs_list ul li a.previous,
    .breadcrumbs .breadcrumbs_list ul li a.current {
        color: white;
    }

    .breadcrumbs .breadcrumbs_list ul li a::after {
        content: ' ';
        display: block;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 15px solid #EFEFEF;
        position: absolute;
        top: 50%;
        margin-top: -22px;
        left: 100%;
        z-index: 2;
    }

    .breadcrumbs .breadcrumbs_list ul li a.previous {
        background-color: #99bcdb;
    }

    .breadcrumbs .breadcrumbs_list ul li a.previous::after {
        border-left-color: #99bcdb;
    }

    .breadcrumbs .breadcrumbs_list ul li a.current {
        background-color: #337ab7;
    }

    .breadcrumbs .breadcrumbs_list ul li a.current::after {
        border-left-color: #337ab7;
    }

    .breadcrumbs .breadcrumbs_list ul li a::before {
        content: ' ';
        display: block;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 15px solid white;
        position: absolute;
        top: 50%;
        margin-top: -22px;
        margin-left: 2px;
        left: 100%;
        z-index: 1;
    }
</style>
